import { getUserEmail } from 'core';
import Mixpanel from 'mixPanel';

const InitializeIntercom = (settings: {} = {}) => {
  if ((window as any)?.Intercom) {
    let intercomSettings: {
      app_id: string;
      email?: string;
      [key: string]: any;
    } = {
      app_id: 'bce2swx3'
    };
    const email = getUserEmail();
    if (email) {
      intercomSettings = {
        ...intercomSettings,
        email
      };
    }

    intercomSettings = {
      ...intercomSettings,
      settings
    };

    (window as any)?.Intercom('boot', intercomSettings);

    const referrer = document ? document.referrer : 'unknown';
    const href = window.location.href;
    const mixpanelDistinctId = Mixpanel.getDistinctId();

    const metadata = {
      href,
      referrer,
      mixpanelDistinctId
    };

    (window as any)?.Intercom('trackEvent', 'initialize', metadata);

    Mixpanel.track('intercom:initialize'); //TODO:: delete once checked is not used
    Mixpanel.track('marketplace:intercom:initialize');
  }
};

export default InitializeIntercom;
